module.exports = __webpack_public_path__ + "static/media/2 Chouhan Millet Brief.57b68ec3.pdf";